query CountryAccessesList($page: Int, $rowsPerPage: Int, $search: String) {
  countryAccesses(page: $page, rowsPerPage: $rowsPerPage, search: $search) {
    count
    nodes {
      id
      title
      type
      countries
      isDefault
      contentsCount
      createdAt
      updatedAt
    }
  }
}
